module.exports = __webpack_public_path__ + "static/media/app-store-download-fr.bf0fd95b.png";